/* eslint-disable @typescript-eslint/no-empty-function */
import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ItemService } from '../../../item.service';
import { ITEM_TTL_ES } from '../../../item.interface';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';

@Component({
  selector: 'pg-item-create',
  templateUrl: './item-create.component.html'
})
export class ItemCreateComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  select = {
    therapistGroups: {
      type: 'multiple',
      openDialog: false,
      ids: []
    },
    activeIngredients: {
      type: 'multiple',
      openDialog: false,
      ids: []
    }
  };

  constructor(private fb: FormBuilder, private itemService: ItemService) {
    super(ITEM_TTL_ES, itemService);
  }

  ngOnInit() {
    this.fg = this.fb.group({
      code: ['', [Validators.required]],
      name: ['', [Validators.required]],
      groupTherapists: [{ value: 'Seleccionar', disabled: true }],
      activeIngredients: [{ value: 'Seleccionar', disabled: true }]
    });
  }

  onSubmit() {
    if (this.fg.valid) {
      this.createItem$(this.parseData(this.fg.value));
    }
  }

  parseData(form) {
    return {
      code: form.code,
      name: form.name,
      groupTherapistsIds: this.select.therapistGroups.ids,
      activeIngredientsIds: this.select.activeIngredients.ids
    };
  }

  onSelectedTherapishGroup(rows) {
    if (rows?.length > 0) {
      this.fg
        .get('groupTherapists')
        .setValue(rows.map((row) => row.description));
      this.select.therapistGroups.ids = rows.map((row) => row.id);
    }
    this.select.therapistGroups.openDialog = false;
  }

  onSelectedActiveIngredients(rows) {
    if (rows?.length > 0) {
      this.fg
        .get('activeIngredients')
        .setValue(rows.map((row) => row.description));
      this.select.activeIngredients.ids = rows.map((row) => row.id);
    }
    this.select.activeIngredients.openDialog = false;
  }
}
